import { render, staticRenderFns } from "./InvoiceMobile.vue?vue&type=template&id=190d34b5&scoped=true&"
import script from "./InvoiceMobile.vue?vue&type=script&lang=js&"
export * from "./InvoiceMobile.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceMobile.vue?vue&type=style&index=0&id=190d34b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d34b5",
  null
  
)

export default component.exports